export default [
  '768px',
];
